import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./assets/style.css";
import { auth, db } from "./firebase";
import firebase from "firebase/compat/app";
import { Element, scroller } from "react-scroll";

const Chapter5_1 = () => {
  const navigate = useNavigate();
  const [selectedAnswers, setSelectedAnswers] = useState({ q1: "", q2: "" });
  const [error, setError] = useState("");
  const [userId, setUserId] = useState(null);

  const questions = [
    {
      question: "Frage 1: Was ist ein Endpunkt in einem Netzwerk?",
      options: [
        {
          value: "A",
          label:
            "Ein Gerät, das mit einem Netzwerk verbunden ist, wie ein Laptop, Smartphone oder IoT-Gerät.",
        },
        {
          value: "B",
          label: "Ein zentraler Server, der alle Daten im Netzwerk verwaltet.",
        },
      ],
      correct: "A",
    },
    {
      question:
        "Frage 2: Warum sind Endpunkte ein beliebtes Ziel für Cyberangriffe?",
      options: [
        {
          value: "A",
          label:
            "Sie sind oft schlechter gesichert, obwohl sie direkt mit Netzwerken und sensiblen Daten verbunden sind.",
        },
        {
          value: "B",
          label:
            "Endpunkte sind sicherheitstechnisch unbedeutend, da sie keine sensiblen Daten verarbeiten.",
        },
      ],
      correct: "A",
    },
  ];
  const location = useLocation();

  useEffect(() => {
    if (location.hash) {
      scroller.scrollTo(location.hash.substring(1), {
        duration: 500,
        smooth: true,
        offset: -50,
      });
    }
  }, [location]);
  
  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      if (user) {
        setUserId(user.uid); 
      } else {
        console.error("Kein authentifizierter Benutzer gefunden");
        setError("Benutzer ist nicht authentifiziert");
        navigate("/cybersecurity/login"); 
      }
    });

    
    return () => unsubscribe();
  }, [navigate]);

  
  useEffect(() => {
    console.log("Aktuelle userId in 5_1.js:", userId);
  }, [userId]);

  const handleLogout = () => {
    
    auth
      .signOut()
      .then(() => {
        
        window.location.href = "/login"; 
      })
      .catch((error) => {
        console.error("Logout fehlgeschlagen:", error);
      });
  };

  const handleAnswerChange = (questionIndex, value) => {
    setSelectedAnswers((prev) => ({
      ...prev,
      [questionIndex]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const correctAnswers = questions.every(
      (q, index) => selectedAnswers[index] === q.correct
    );

    if (correctAnswers) {
      try {
        if (!userId) {
          console.error("userId ist nicht definiert");
          setError("Ein Fehler ist aufgetreten.");
          return;
        }

        
        const userDoc = await db.collection("cybersecurityProgress").doc(userId).get();

        console.log("userDoc:", userDoc.exists);

        if (userDoc.exists) {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .update({
              lastChapter: "5_1",
              completedChapters:
                firebase.firestore.FieldValue.arrayUnion("5_1"),
            });
          console.log("Dokument aktualisiert mit Kapitel 5_1.");
        } else {
          
          await db
            .collection("cybersecurityProgress")
            .doc(userId)
            .set({
              lastChapter: "5_1",
              completedChapters: ["5_1"],
            });
          console.log("Dokument erstellt mit Kapitel 5_1");
        }

        navigate("/cybersecurity/5_2"); 
      } catch (error) {
        console.error("Fehler beim Aktualisieren des Fortschritts:", error);
        setError("Ein Fehler ist aufgetreten. Versuche es später erneut.");
      }
    } else {
      setError("Die Antworten sind nicht korrekt. Versuche es erneut.");
    }
  };
  return (
    <div className="container">
      <div className="container py-5">
        <img
          src="/images/zebbs_Logo.svg"
          class="d-block mx-auto mb-4"
          alt=""
          style={{ width: "20%" }}
        />
        <div className="d-flex justify-content-between align-items-center mb-5 p-3 bg-body-tertiary rounded-3">
          {/* Breadcrumbs */}
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb breadcrumb-chevron mb-0">
              {/* Startseite (Home) */}
              <li className="breadcrumb-item">
                <Link className="link-body-emphasis" to="/cybersecurity/course-overview">
                  <i className="bi bi-house-door-fill"></i>
                  <span className="visually-hidden">Home</span>
                </Link>
              </li>

              {/* Library Link */}
              <li className="breadcrumb-item">
                <Link
                  className="link-body-emphasis fw-semibold text-decoration-none"
                  to="/cybersecurity/course-overview"
                >
                  5. Endpunktsicherheit
                </Link>
              </li>

              {/* Aktuelle Seite */}
              <li className="breadcrumb-item active" aria-current="page">
                Was sind Endpunkte?
              </li>
            </ol>
          </nav>

          {/* Logout-Button */}
          <button className="btn btn-outline-dark" onClick={handleLogout}>
            Logout
          </button>
        </div>

        <div
          className="p-5 m-0 rounded-3"
          style={{
            position: "relative",
            backgroundColor: "#009fe0",
            margin: "25px",
            textAlign: "center",
          }}
        >
          <h3 className="text-center p-5">Kapitel 5: Endpunktsicherheit</h3>
          <h2 className="text-center p-3">Was sind Endpunkte? </h2>
          <img
            src="/images/ov-endpoint.png"
            alt="Endpunkte"
            style={{ position: "relative", maxWidth: "50%", height: "auto" }}
          />
        </div>

        <div className="p-5 text-center">
          <p className="col-lg-11 pt-5 mx-auto">
            Ein Endpunkt ist jedes Gerät oder jede Komponente, die mit einem
            Netzwerk verbunden ist und Daten sendet oder empfängt. Dazu gehören
            Computer, Smartphones, Tablets, Server, Drucker oder IoT-Geräte wie
            smarte Thermostate oder Überwachungskameras. Es ist sozusagen die
            "letzte Station" in einem Netzwerk, an der Benutzer oder Geräte
            direkt arbeiten oder auf Ressourcen zugreifen.
            <br />
            <br />
            Angreifer wissen, dass Endpunkte oft weniger gut geschützt sind als
            zentrale IT-Systeme wie Netzwerke und nutzen sie daher gezielt als
            <strong> Einstiegspunkte für Cyberangriffe. </strong>Genau hier
            setzt die Endpunktsicherheit an: Sie umfasst alle Maßnahmen, um
            diese Geräte vor Angriffen zu schützen und ihre Sicherheit zu
            gewährleisten.
          </p>

          <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
            <img
              src="/images/fact.svg"
              alt="Transparent"
              style={{
                position: "relative",
                maxWidth: "8%",
                height: "auto",
              }}
            />
            Die Zahl vernetzter Endgeräte wächst weltweit weiter stark. Prognosen gehen davon aus, dass sich die Anzahl der IoT- und vernetzten Geräte von rund 21 Milliarden im Jahr 2025 auf etwa 39 Milliarden im Jahr 2030 erhöhen wird. Dieses kontinuierliche Wachstum vergrößert die Angriffsfläche für Unternehmen erheblich und unterstreicht die zunehmende Bedeutung einer effektiven Endpunktsicherheit (IoT Analytics, 2025).
          </p>
        </div>
      </div>

      <div className="grey-section">
        <div className="py-5 container">
          <div className="p-5 text-center">
            <h3 className="p-5">Warum sind Endpunkte so anfällig?</h3>
            <p className="col-lg-11 mx-auto">
              Endpunkte befinden sich am "Rand" eines Netzwerks und sind häufig
              den direkten <strong> Interaktionen von Menschen </strong>{" "}
              ausgesetzt. Die zählen zu den am schlechtesten berechenbaren Faktoren in der
              Cybersecurity. Mitarbeiter nutzen ihre Laptops möglicherweise in
              unsicheren öffentlichen WLAN-Netzwerken, laden E-Mail-Anhänge mit{" "}
              <Link to="/cybersecurity/3_1" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Malware{" "}
              </Link>{" "}
              herunter, oder fallen auf{" "}
              <Link to="/cybersecurity/2_4" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Phishing-Links{" "}
              </Link>
              rein.
              <br />
              <br />
              Durch die Zunahme der Arbeit im Homeoffice hat die Zahl der
              Endpunkte in den letzten Jahren exponentiell zugenommen. Jedes
              dieser Geräte stellt ein potenzielles Risiko dar. Viele
              Unternehmen haben nicht die volle Kontrolle über diejenigen Endgeräte,
              die in ihren Netzwerken genutzt werden. Während zentrale Server oft von der
              IT-Abteilung streng überwacht und gesichert werden, können
              Endgeräte aufgrund ihrer Mobilität, Diversität und Nutzung durch
              den Menschen schwerer kontrolliert werden. Dabei kann ein
              ungeschütztes Endgerät nicht nur selbst kompromittiert werden,
              sondern auch als{" "}
              <strong>
                {" "}
                Einfallstor für weitere Angriffe auf das gesamte Netzwerk{" "}
              </strong>{" "}
              ausgenutzt werden.
              <br />
              <br />
              Endpunkte wie smarte Kameras, Thermostate oder industrielle
              Sensoren, die zu den IoT-Geräten (Internet of Things) zählen,
              werden häufig mit{" "}
              <strong> minimalen Sicherheitsvorkehrungen </strong> entwickelt. Sie 
              verfügen über eingeschränkte Rechenleistung und Speicher.
              Dadurch fehlt ihnen oft die Möglichkeit, komplexe
              Sicherheitsprotokolle wie{" "}
              <Link to="/cybersecurity/4_3#firewall" className="icon-link">
                <svg className="bi" aria-hidden="true">
                  <use xlinkHref="#book"></use>
                </svg>{" "}
                Firewall
              </Link>
              oder{" "}
              <Link to="/cybersecurity/4_4" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Verschlüsselung{" "}
              </Link>
              zu implementieren. Hinzu kommt, dass IoT-Geräte häufig mit
              Standardpasswörtern ausgeliefert werden, die von Nutzern nicht
              geändert werden, was Hackern den Zugang erleichtert.
            </p>
            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              Im Jahr 2017 wurde das österreichische 4-Sterne Seehotel Jägerwirt
              Opfer eines Cyberangriffs, der durch die Vernetzung seiner Systeme
              ermöglicht wurde. Hacker nutzten eine Schwachstelle im internen
              Netzwerk des Hotels aus, welches die Türschließsysteme betraf. Sie
              sperrten die elektronischen Türschlösser der Gästezimmer und
              forderten ein Lösegeld von 2 Bitcoin, damals umgerechnet 1500
              Euro, um den Zugriff wiederherzustellen. Der Hotelmanager zahlte
              den Betrag, da sich der Vorfall in der Winter-Hauptsaison
              ereignete. Wenige Tage darauf erfolgte allerdings der nächste
              Angriff.
            </p>
          </div>
        </div>
      </div>

      <div className="gelb-section">
        <div className="py-5 container">
          <div className="p-5 text-center">
            <h3 className="p-5">
              Herausforderungen bei der Endpunktsicherheit
            </h3>
            <p className="col-lg-11 mx-auto">
              Eine der größten Herausforderungen besteht in der{" "}
              <strong> Heterogenität</strong> der Endgeräte. Unternehmen müssen
              heute eine Vielzahl von Geräten und Betriebssystemen sichern, die
              oft unterschiedliche Sicherheitsanforderungen haben. Smartphones
              mit veralteten Betriebssystemen, IoT-Geräte ohne
              Sicherheitsupdates oder private Laptops mit fragwürdiger Software
              können schnell zu einer Schwachstelle werden.
              <br />
              <br />
              Mitarbeiter nutzen aus Bequemlichkeit oder Effizienzgründen oft
              private Geräte oder installieren Apps, die nicht von der
              IT-Abteilung genehmigt wurden. Solche Geräte und Anwendungen
              bleiben oft unentdeckt und werden nicht ausreichend geschützt.
              Dieser Bereich wird auch als <strong> Shadow-IT </strong>{" "}
              bezeichnet. Er stellt ein erhebliches Sicherheitsrisiko dar.
              <br />
              <br />
              Hinzu kommt, dass viele Endgeräte außerhalb der geschützten
              Unternehmensumgebung betrieben werden. Mitarbeiter greifen von
              Cafés, Hotels oder sogar während des Fluges auf
              Unternehmensnetzwerke zu. Solche Verbindungen sind oft unsicher
              und machen Endpunkte besonders anfällig für Angriffe wie{" "}
              <Link to="/cybersecurity/3_5" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Man-in-the-Middle{" "}
              </Link>{" "}
              -Attacken, bei denen Angreifer Daten während der Übertragung
              abfangen und verändern.
              <br />
              <br />
              Eine weitere Herausforderung ist das menschliche Verhalten. Selbst
              mit der besten Sicherheitssoftware bleiben Endgeräte anfällig,
              wenn Nutzer{" "}
              <Link to="/cybersecurity/2_3" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                unsichere Passwörter{" "}
              </Link>{" "}
              verwenden, Software-Updates ignorieren oder auf Phishing-Links
              klicken.
            </p>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-beispiel rounded-2">
              <img
                src="/images/attack.svg"
                alt="Angriff"
                style={{
                  position: "relative",
                  maxWidth: "10%",
                  height: "auto",
                }}
              />
              2017 nutzten Hacker in einem Casino in Las Vegas ein
              IoT-verbundenes Thermostat in einem Aquarium, um Zugang zum
              internen Netzwerk des Casinos zu erhalten. Von dort aus konnten
              sie eine Datenbank mit sensiblen Informationen über hochrangige
              Kunden auslesen und an einen externen Server senden. Das
              Thermostat war mit dem Hauptnetzwerk des Casinos verbunden und
              verfügte über keine angemessene Zugriffskontrolle oder
              Verschlüsselung.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="py-5 container">
          <div className="pt-5 text-center">
            <h3 className="p-5">Strategien in der Endpunktsicherheit</h3>
            <p className="col-lg-11 mx-auto">
              Die Endpunktsicherheit muss zu einem{" "}
              <strong>
                {" "}
                integralen Bestandteil der Sicherheitsarchitektur{" "}
              </strong>{" "}
              eines Unternehmens werden. Sie darf keine isolierte Maßnahme sein,
              sondern sollte als ein zentraler Baustein einer umfassenden
              Cybersecurity-Strategie betrachtet werden.
              <br />
              <br />
              Moderne Endpoint-Sicherheitslösungen integrieren dafür häufig
              <strong>
                {" "}
                Endpoint Protection Platforms (EPP)-Tools{" "}
              </strong> und{" "}
              <strong>Endpoint Detection and Response (EDR)-Tools, </strong> um
              umfassenden Schutz zu bieten.
              <br />
              <br />
              <strong>Endpoint Protection Platforms (EPP) </strong> schützen die
              Endgeräte <strong> präventiv </strong> vor einer Vielzahl von
              Bedrohungen. Hier werden klassische Antiviren-Software mit
              modernen Technologien wie Verhaltensanalyse und
              Bedrohungsdatenbanken kombiniert, um Malware,{" "}
              <Link to="/cybersecurity/2_4" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Phishing{" "}
              </Link>{" "}
              und{" "}
              <Link to="/cybersecurity/3_2" className="icon-link">
                {" "}
                <svg className="bi" aria-hidden="true">
                  {" "}
                  <use xlinkHref="#book"></use>{" "}
                </svg>{" "}
                Ransomware{" "}
              </Link>{" "}
              zu verhindern. Zusätzlich unterstützt EPP Unternehmen dabei, den
              Zugriff auf Endgeräte zu kontrollieren und Sicherheitsrichtlinien
              einzuhalten.
              <br />
              <br />
              <br />
              <br />
              <strong>Endpoint Detection and Response (EDR) </strong>
              geht über die reine Prävention hinaus, indem es Bedrohungen
              erkennt, analysiert und <strong> aktiv </strong> auf die
              Sicherheitsvorfälle reagiert. <br />
              <br />
              Ein EDR-Tool arbeitet auf mehreren Ebenen, um Endgeräte vor
              Sicherheitsbedrohungen zu schützen und auf Vorfälle schnell zu
              reagieren.{" "}
            </p>
            <Element name="edr">
              <section class="p-5 text-start">
                <ul class="timeline">
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">1. Echtzeitüberwachung</h5>

                    <p>
                      Im ersten Schritt erfolgt die Echtzeit-Überwachung, bei
                      der EDR-Tools kontinuierlich alle Aktivitäten auf den
                      Endgeräten überwachen. Dazu gehören Prozesse,
                      Dateioperationen und Netzwerkverbindungen, die in Echtzeit
                      analysiert und protokolliert werden.
                    </p>
                  </li>

                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">2. Erkennung von Bedrohungen:</h5>

                    <p>
                      Anhand dieser gesammelten Daten erfolgt die Erkennung von
                      Bedrohungen. EDR-Systeme vergleichen die beobachteten
                      Aktivitäten mit bekannten Angriffsmustern, um Bedrohungen
                      wie Malware sofort zu identifizieren. Darüber hinaus sind
                      sie in der Lage, unbekannte Gefahren durch
                      Verhaltensanalyse und die Erkennung von Anomalien zu
                      erkennen, die auf verdächtige Aktivitäten hinweisen.
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">3. Reaktion auf Bedrohung:</h5>

                    <p>
                      Im Falle eines erkannten Sicherheitsvorfalls tritt die
                      Reaktionsphase in Kraft. Hier kann EDR automatisch
                      Maßnahmen ergreifen, ohne auf manuelles Eingreifen
                      angewiesen zu sein. Dazu gehört beispielsweise das
                      Isolieren kompromittierter Geräte vom Netzwerk, das
                      Stoppen verdächtiger Prozesse oder das Verschieben
                      infizierter Dateien in eine Quarantäne-Zone.
                    </p>
                  </li>
                  <li class="timeline-item mb-5">
                    <h5 class="fw-bold">4. Forentische Untersuchung:</h5>

                    <p>
                      Schließlich ermöglicht die forensische Analyse eine
                      detaillierte Untersuchung des Vorfalls. EDR-Lösungen
                      speichern umfassende Protokolle und stellen
                      Analysewerkzeuge bereit, die IT-Teams bei der
                      Rekonstruktion des Angriffs unterstützen. So lassen sich
                      Schwachstellen identifizieren, Angriffspfade
                      nachvollziehen und gezielte Maßnahmen zur Vermeidung
                      zukünftiger Vorfälle ableiten.
                    </p>
                  </li>
                </ul>
              </section>
            </Element>

            <p className="col-lg-9 mx-auto d-inline-flex p-5 m-5 text-decoration-none border-danger rounded-2">
              <img
                src="/images/fact.svg"
                alt="Transparent"
                style={{
                  position: "relative",
                  maxWidth: "8%",
                  height: "auto",
                }}
              />
              Laut einem Bericht von Ponemon Institute ("State of Endpoint
              Security Risk"), der in Zusammenarbeit mit dem
              IT-Sicherheitsunternehmen Morphisec erstellt wurde, sind fehlende
              Transparenz und mangelnde Inventarisierung der Endpunkte eines der
              größten Probleme für Unternehmen. Mehr als 40% der Unternehmen
              haben Schwierigkeiten, den Überblick über alle Endgeräte in ihrem
              Netzwerk zu behalten. Diese Unsichtbarkeit führt dazu, dass viele
              Geräte ungesichert bleiben und Sicherheitslücken entstehen.
            </p>
          </div>
        </div>
      </div>

      <div className="white-section">
        <div className="pt-5 container">
          <div
            className="safe rounded-2 text-center"
            style={{ backgroundColor: "#fec748" }}
          >
            <img
              src="/images/abwehr.svg"
              alt="Abwehr"
              style={{
                position: "relative",
                maxWidth: "7%",
                height: "auto",
              }}
            />
            <h3 className="p-5">
              Best Practices für den Schutz von Endpunkten
            </h3>
            <p className="col-lg-11 mx-auto">
              Ein effektiver Ansatz beginnt mit der vollständigen
              <strong> Inventarisierung aller Endgeräte. </strong> Unternehmen
              müssen wissen, welche Geräte Zugriff auf ihre Netzwerke haben, um
              Sicherheitslücken zu schließen.
              <br />
              <br />
              Moderne Sicherheitslösungen wie{" "}
              <strong> Endpoint Protection Platforms (EPP) </strong> bieten
              umfassenden Schutz, indem sie Funktionen wie Antiviren-Schutz,
              Firewall und Verhaltensanalyse in einer Plattform vereinen.
              <br />
              Beliebte EPP-Tools sind z. B. Symantec Endpoint Protection,
              Kaspersky Endpoint Security oder McAfee Endpoint Security.
              <br />
              <br />
              Ergänzend dazu ermöglichen{" "}
              <strong>
                {" "}
                Endpoint Detection and Response (EDR)-Systeme{" "}
              </strong>{" "}
              eine kontinuierliche Überwachung und schnelle Reaktion auf
              verdächtige Aktivitäten. Diese Systeme erkennen nicht nur bekannte
              Bedrohungen, sondern analysieren auch unbekannte Verhaltensmuster,
              um potenzielle Angriffe frühzeitig zu stoppen.
              <br />
              <br />
              <br />
              Bekannte EDR-Tools sind z. B. Microsoft Defender for Endpoint oder
              CrowdStrike Falcon. Es gibt auch Tools, die beide Schutzfunktionen
              direkt zusammen anbieten, wie z. B. Bitdefender GravityZone oder
              Sophos Intercept X Advanced with EDR.
              <br />
              <br />
              Darüber hinaus sind regelmäßige Software-Updates und
              <strong> Patch-Management </strong> entscheidend, um bekannte
              Schwachstellen zu schließen. Unternehmen sollten sicherstellen,
              dass alle Endgeräte automatisch aktualisiert werden und keine
              veraltete Software nutzen.
              <br />
              <br />
              Sobald ein Endpunkt kompromittiert wird, muss er sofort isoliert
              werden, um eine Ausbreitung zu verhindern. Viele EDR-Lösungen
              bieten eine automatische <strong> Endpunktisolierung </strong> an,
              sodass ein infiziertes Gerät keinen Zugang zu anderen
              Netzwerkteilen hat.
              <br />
              <br />
              Auch hier ist die{" "}
              <strong>Sensibilisierung der Mitarbeiter </strong>ein
              weiterer Schlüssel zur Sicherheit. Regelmäßige Schulungen können
              helfen, Risiken wie Phishing-Angriffe oder unsichere WLAN-Nutzung
              zu minimieren.
            </p>
          </div>
        </div>
        {/* Fragenteil */}
        <div className="container pt-5 my-5">
          <div className="text-center m-4">
            <h2>Überprüfe dein Wissen</h2>
            <p className="col-lg-11 mx-auto">
              Mit den richtigen Antworten kommst du weiter!
            </p>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-9 text-start">
              <form onSubmit={handleSubmit}>
                {questions.map((question, index) => (
                  <div key={index} className="mb-4">
                    <p className="fs-4">{question.question}</p>{" "}
                    {question.options.map((option) => (
                      <div key={option.value} className="form-check">
                        <input
                          className="form-check-input me-2"
                          type="radio"
                          name={`question${index}`}
                          value={option.value}
                          checked={selectedAnswers[index] === option.value}
                          onChange={() =>
                            handleAnswerChange(index, option.value)
                          }
                        />
                        <label className="form-check-label fs-5">
                          {option.label}
                        </label>{" "}
                      </div>
                    ))}
                  </div>
                ))}
                {error && <p className="text-danger">{error}</p>}
                <div className="text-center">
                  <button type="submit" className="btn btn-primary">
                    überprüfen
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
        {/* Ende Fragenteil */}
      </div>
    </div>
  );
};

export default Chapter5_1;
